// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import AppTabController from "../../services/app-tab-controller";
function CiAssignmentViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.ConfigurationItem = parent;
    self.Bao = Bao;
    self.GoToOwner = function (item) {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.ConfigurationItem.OwnerId()
        });
        newTab.ObjectId(self.ConfigurationItem.OwnerId());
        AppTabController.AddTab(newTab);
    };
    self.GoToCustomer = function (item) {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Customer");
        newTab.UrlData({
            id: self.ConfigurationItem.CustomerId()
        });
        newTab.ObjectId(self.ConfigurationItem.CustomerId());
        AppTabController.AddTab(newTab);
    };
    self.GoToAdvisorPerson = function (item) { };
    self.SearchOwnerVisible = ko.observable(false);
    self.ParentCheckBoxesVisible = ko.observable(false);
    self.OwnerCheckBoxesVisible = ko.observable(false);
    self.ConfigurationItem.ParentOwnerId.subscribe(function (value) {
        self.ConfigurationItem.OwnerId(value);
    });
    self.ParentCheckBoxesVisible.subscribe(function (value) {
        if (value === false) {
            self.ConfigurationItem.UseParentCustomer(false);
            self.ConfigurationItem.UseParentLocation(false);
            self.ConfigurationItem.UseParentAccountAssignment(false);
            self.ConfigurationItem.UseParentDepartment(false);
            self.ConfigurationItem.UseParentBuilding(false);
            self.ConfigurationItem.UseParentRoom(false);
            self.ConfigurationItem.UseParentAdvisorPerson(false);
        }
    });
    self.Refresh = function () {
        var def = $.Deferred();
        self.GetOwner().then(function () {
            if (self.ConfigurationItem.ParentConfigurationItemId() != null) {
                self.SetParent(self.ConfigurationItem.ParentConfigurationItemId()).then(def.resolve);
            }
            else {
                def.resolve();
            }
        });
        return def.promise();
    };
    self.InitializeVisibilityTrigger = function () {
        if (self.ConfigurationItem.ParentConfigurationItemId() != null) {
            self.ParentCheckBoxesVisible(true);
        }
        if (self.ConfigurationItem.OwnerId() != null) {
            self.OwnerCheckBoxesVisible(true);
        }
    };
    self.ConfigurationItem.AlternateOwner.subscribe(function (value) {
        self.SetOwner(value);
    });
    self.SetOwner = function (value) {
        if (value == false) {
            if (self.ConfigurationItem.ParentConfigurationItemId() != null) {
                self.ConfigurationItem.OwnerId(self.ConfigurationItem.Parent.OwnerId());
            }
        }
    };
    self.OwnerCheckBoxesVisible.subscribe(function (value) {
        if (value == false) {
            self.ConfigurationItem.UseOwnerCustomer(value);
            self.ConfigurationItem.UseOwnerLocation(value);
            self.ConfigurationItem.UseOwnerAccountAssignment(value);
            self.ConfigurationItem.UseOwnerDepartment(value);
            self.ConfigurationItem.UseOwnerBuilding(value);
            self.ConfigurationItem.UseOwnerRoom(value);
        }
    });
    self.OwnerLoaded = ko.observable(false);
    self.ConfigurationItem.OwnerId.subscribe(function (ownerId) {
        self.OwnerLoaded(false);
        if (ownerId == null) {
            self.OwnerCheckBoxesVisible(false);
        }
        else {
            self.OwnerCheckBoxesVisible(true);
        }
        self.GetOwner();
    });
    self.GetOwner = function () {
        return Bao.post("ConfigurationItemTab/GetOwner", JSON.stringify({
            id: self.ConfigurationItem.OwnerId()
        }), function (value) {
            self.ConfigurationItem.TabPage.DirtyFlag.pause();
            ko.map.fromJS(value, self.ConfigurationItem.Owner);
            self.OwnerLoaded(true);
            self.ConfigurationItem.TabPage.DirtyFlag.resume();
        });
    };
    self.ParentLoaded = ko.observable(false);
    self.ConfigurationItem.ParentConfigurationItemId.subscribe(function (parentId) {
        self.SetParent(parentId);
    });
    self.SetParent = function (parentId) {
        self.ParentLoaded(false);
        if (parentId == null) {
            self.ParentCheckBoxesVisible(false);
        }
        else {
            self.ParentCheckBoxesVisible(true);
        }
        return Bao.post("ConfigurationItemTab/GetParent", JSON.stringify({
            id: parentId
        }), function (value) {
            self.ConfigurationItem.TabPage.DirtyFlag.pause();
            ko.map.fromJS(value, self.ConfigurationItem.Parent);
            self.ParentLoaded(true);
            self.SetOwner(self.ConfigurationItem.AlternateOwner());
            self.ConfigurationItem.TabPage.DirtyFlag.resume();
        });
    };
    self.ConfigurationItem.CustomerId.subscribe(function () {
        self.ConfigurationItem.LocationId(null);
        self.ConfigurationItem.LocationName("");
    });
    self.UseOwnerCustomerComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseOwnerCustomer() == true && self.ConfigurationItem.OwnerId() != null && self.OwnerLoaded() == true) {
            self.ConfigurationItem.CustomerId(self.ConfigurationItem.Owner.CustomerId());
            self.ConfigurationItem.CustomerName(self.ConfigurationItem.Owner.CustomerName());
            self.ConfigurationItem.UseParentCustomer(false);
        }
    });
    self.ConfigurationItem.UseOwnerCustomer.subscribe(function (value) {
        if (value == true) {
            self.ConfigurationItem.UseParentLocation(false);
            self.ConfigurationItem.UseParentAccountAssignment(false);
            self.ConfigurationItem.LocationId(null);
            self.ConfigurationItem.LocationName(null);
            self.ConfigurationItem.AccountAssignment(null);
            ;
        }
        else {
            self.ConfigurationItem.UseOwnerLocation(false);
            self.ConfigurationItem.UseOwnerAccountAssignment(false);
        }
    });
    self.UseParentCustomerComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentCustomer() == true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() == true) {
            self.ConfigurationItem.CustomerId(self.ConfigurationItem.Parent.CustomerId());
            self.ConfigurationItem.CustomerName(self.ConfigurationItem.Parent.CustomerName());
            self.ConfigurationItem.UseOwnerCustomer(false);
        }
    });
    self.ConfigurationItem.UseParentCustomer.subscribe(function (value) {
        if (value == true) {
            self.ConfigurationItem.UseOwnerLocation(false);
            self.ConfigurationItem.UseOwnerAccountAssignment(false);
            self.ConfigurationItem.LocationId(null);
            self.ConfigurationItem.LocationName(null);
            self.ConfigurationItem.AccountAssignment(null);
        }
        else {
            self.ConfigurationItem.UseParentLocation(false);
            self.ConfigurationItem.UseParentAccountAssignment(false);
        }
    });
    self.UseParentAdvisorPersonComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentAdvisorPerson() === true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() === true) {
            self.ConfigurationItem.AdvisorPersonId(self.ConfigurationItem.Parent.AdvisorPersonId());
            self.ConfigurationItem.AdvisorPersonName(self.ConfigurationItem.Parent.AdvisorPersonName());
        }
    });
    self.UseOwnerLocationComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseOwnerLocation() == true && self.ConfigurationItem.OwnerId() != null && self.OwnerLoaded() == true) {
            self.ConfigurationItem.LocationId(self.ConfigurationItem.Owner.LocationId());
            self.ConfigurationItem.LocationName(self.ConfigurationItem.Owner.LocationName());
            self.ConfigurationItem.UseParentLocation(false);
        }
    });
    self.UseParentLocationComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentLocation() == true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() == true) {
            self.ConfigurationItem.LocationId(self.ConfigurationItem.Parent.LocationId());
            self.ConfigurationItem.LocationName(self.ConfigurationItem.Parent.LocationName());
            self.ConfigurationItem.UseOwnerLocation(false);
        }
    });
    self.UseOwnerAccountAssignmentComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseOwnerAccountAssignment() == true && self.ConfigurationItem.OwnerId() != null && self.OwnerLoaded() == true) {
            self.ConfigurationItem.AccountAssignmentTypeId(self.ConfigurationItem.Owner.AccountAssignmentTypeId());
            self.ConfigurationItem.AccountAssignment(self.ConfigurationItem.Owner.AccountAssignment());
            self.ConfigurationItem.UseParentAccountAssignment(false);
        }
    });
    self.UseParentAccountAssignmentComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentAccountAssignment() == true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() == true) {
            self.ConfigurationItem.AccountAssignmentTypeId(self.ConfigurationItem.Parent.AccountAssignmentTypeId());
            self.ConfigurationItem.AccountAssignment(self.ConfigurationItem.Parent.AccountAssignment());
            self.ConfigurationItem.UseOwnerAccountAssignment(false);
        }
    });
    self.UseOwnerDepartmentComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseOwnerDepartment() == true && self.ConfigurationItem.OwnerId() != null && self.OwnerLoaded() == true) {
            self.ConfigurationItem.DepartmentId(self.ConfigurationItem.Owner.DepartmentId());
            self.ConfigurationItem.DepartmentName(self.ConfigurationItem.Owner.DepartmentName());
            self.ConfigurationItem.UseParentDepartment(false);
        }
    });
    self.UseParentDepartmentComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentDepartment() == true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() == true) {
            self.ConfigurationItem.DepartmentId(self.ConfigurationItem.Parent.DepartmentId());
            self.ConfigurationItem.DepartmentName(self.ConfigurationItem.Parent.DepartmentName());
            self.ConfigurationItem.UseOwnerDepartment(false);
        }
    });
    self.UseOwnerBuildingComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseOwnerBuilding() == true && self.ConfigurationItem.OwnerId() != null && self.OwnerLoaded() == true) {
            self.ConfigurationItem.BuildingId(self.ConfigurationItem.Owner.BuildingId());
            self.ConfigurationItem.BuildingName(self.ConfigurationItem.Owner.BuildingName());
            self.ConfigurationItem.UseParentBuilding(false);
        }
    });
    self.UseParentBuildingComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentBuilding() == true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() == true) {
            self.ConfigurationItem.BuildingId(self.ConfigurationItem.Parent.BuildingId());
            self.ConfigurationItem.BuildingName(self.ConfigurationItem.Parent.BuildingName());
            self.ConfigurationItem.UseOwnerBuilding(false);
        }
    });
    self.UseOwnerRoomComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseOwnerRoom() == true && self.ConfigurationItem.OwnerId() != null && self.OwnerLoaded() == true) {
            self.ConfigurationItem.Room(self.ConfigurationItem.Owner.Room());
            self.ConfigurationItem.UseParentRoom(false);
        }
    });
    self.UseParentRoomComputed = ko.computed(function () {
        if (self.ConfigurationItem.UseParentRoom() == true && self.ConfigurationItem.ParentConfigurationItemId() != null && self.ParentLoaded() == true) {
            self.ConfigurationItem.Room(self.ConfigurationItem.Parent.Room());
            self.ConfigurationItem.UseOwnerRoom(false);
        }
    });
    self.InitializeVisibilityTrigger();
    self.CompleteCheck = function () {
        if (self.ConfigurationItem.CustomerId() == null) {
            return false;
        }
        if (self.ConfigurationItem.LocationId() == null) {
            return false;
        }
        return true;
    };
    self.init = function () { };
    self.loaded = function () {
        var dirty = false;
        if (parent.TabPage.DirtyFlag != null) {
            dirty = parent.TabPage.DirtyFlag();
        }
        if (parent.Parent != null) {
            self.ParentLoaded(true);
        }
        if (parent.Owner != null) {
            self.OwnerLoaded(true);
        }
        if (self.ConfigurationItem.ParentConfigurationItemId() != null) {
            self.SetParent(self.ConfigurationItem.ParentConfigurationItemId());
        }
        if (parent.TabPage.DirtyFlag != null && dirty == false) {
            parent.TabPage.DirtyFlag(false);
        }
    };
}
;
Bao.inherit(CiAssignmentViewModel, ChildTabViewModel);
export default CiAssignmentViewModel;